import React, { FC, HTMLAttributes } from "react";
import classnames from "classnames";

import Styles from "./AppBtn.module.scss";
import loadable from "@loadable/component";
// import Skeleton from "../skeleton/Skeleton";

const Skeleton = loadable(
    () => import(/* webpackChunkName: "SkeletonLoader", webpackPrefetch: true */ "../skeleton/Skeleton")
);

export interface AppBtnProps extends HTMLAttributes<HTMLElement> {
    onClick?: React.DOMAttributes<HTMLButtonElement>["onClick"];
    type?:
        | "primary"
        | "secondary"
        | "success"
        | "danger"
        | "warning"
        | "loading"
        | "link"
        | "green"
        | "darkgray"
        | "lightgray"
        | "lightred";
    isBlockBtn?: boolean;
    fillType?: "outline" | "solid";
    width?: string;
    className?: string;
    classDisabled?: string;
    isInHoverState?: boolean;
    isMobile?: boolean;
    disabled?: boolean;
    btnType?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
}

const AppBtn: FC<AppBtnProps> = ({
    onClick,
    type = "primary",
    fillType = "solid",
    className,
    classDisabled,
    isBlockBtn,
    width,
    style,
    isInHoverState = false,
    isMobile = false,
    disabled = false,
    btnType = "button",
    id,
    ...props
}) => {
    return (
        <button
            className={classnames(
                Styles.main,
                Styles[type],
                Styles[fillType],
                isMobile ? Styles.mobile : Styles.desktop,
                isInHoverState ? Styles.hover : "",
                disabled ? Styles.disabled : "",
                disabled ? classDisabled : "",
                className
            )}
            disabled={disabled}
            style={{ width: isBlockBtn ? "100%" : width, ...style }}
            onClick={onClick}
            type={btnType}
            id={id}
            data-testid={id}
            {...props}
        >
            {type === "loading" ? <Skeleton type="button" /> : props.children}
        </button>
    );
};

export default AppBtn;
